export const getAddJobReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_JOB_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "ADD_JOB_SUCCESS":
      return {
        loading: false,
        success: true,
      };
    case "ADD_JOB_FAILED":
      return {
        loading: false,
        error: action.payload,
      };

    case "ALL_JOB_CLEAR":
      return {
        loading: false,
        success: false,
      };

    default:
      return state;
  }
};

export const getAllJobReducer = (state = { job: [] }, action) => {
  switch (action.type) {
    case "GET_JOB_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "GET_JOB_SUCCESS":
      return {
        loading: false,
        job: action.payload,
      };
    case "GET_JOB_FAILED":
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
